import { combineReducers } from "@reduxjs/toolkit";
import fuse from "./fuse";
import i18n from "./i18nSlice";
import user from "./userSlice";
import empAdminSlice from "../main/empAdmin/store/empAdminSlice";
import userSlice from "../main/userAdmin/store/userSlice";
import reportSlice from "../main/reports/store/reportSlice";
import localSlice from "../main/localAdmin/store/localAdminSlice";

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    fuse,
    i18n,
    user,
    empAdminApp: combineReducers({
      admin: empAdminSlice, 
    }),
		userApp: combineReducers({
      admin: userSlice, 
    }),
    localApp: combineReducers({
      admin: localSlice,
    }),
    reportApp: combineReducers({
      report: reportSlice
    }),
    ...asyncReducers,
  });

  /*
	Reset the redux store when user logged out
	 */
  if (action.type === "user/userLoggedOut") {
    // state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
